import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn_none.png";
import Normalbtn from "../assets/normal_btn_none.png";
import Badbtn from "../assets/bad_btn_none.png";

import ttsAudio from "../assets/sound/tts_05.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/5.mp3";
import ttsAudio_jp from "../assets/sound/jp/5.mp3";
import ttsAudio_cn from "../assets/sound/cn/5.mp3";
import ttsAudio_mn from "../assets/sound/mn/5.mp3";

const About2 = () => {
    const { t,i18n } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { sex } = useParams();
    const { birth } = useParams();


    const [tody,SetToday]=useState();

    const audioRef = useRef(null);

    const clickNext= item => {

        navigate('/about2_2/'+name+'/'+sex+'/'+birth+'/'+item);
    };
    
    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="input-area">
                <div className="step_area">STEP 4</div>
                <div className="title_area">
                    <h1 className="num_title">(4/5)</h1>
                    <h2 className="title">{t("오늘의 기분을 선택해주세요")}</h2>
                </div>

                <div className="input_section" style={{ background: "#ffffff" }}>
                    <div className="flex_area">
                        {lng === "ko" && (
                            <ul>
                                <li>
                                    <button className="checkBtn good" onClick={() => clickNext("1")}></button>
                                </li>
                                <li>
                                    <button className="checkBtn normal" onClick={() => clickNext("2")}></button>
                                </li>
                                <li>
                                    <button className="checkBtn bad" onClick={() => clickNext("3")}></button>
                                </li>
                            </ul>
                        )}

                        {lng != "ko" && (
                            <ul>
                                <li>
                                    <button className="checkBtn good" onClick={() => clickNext("1")} style={{ backgroundImage: `url(${Goodbtn})` }}></button>
                                </li>
                                <li>
                                    <button className="checkBtn normal" onClick={() => clickNext("2")} style={{ backgroundImage: `url(${Normalbtn})` }}></button>
                                </li>
                                <li>
                                    <button className="checkBtn bad" onClick={() => clickNext("3")} style={{ backgroundImage: `url(${Badbtn})` }}></button>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About2;
